module.exports = __webpack_public_path__ + "static/media/center-image.48413bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/isotope-images/center-image.png
// module id = 160
// module chunks = 0